import React from 'react';
import { OPTIONS } from '../mvData';
import ImagePreviewStrip from './ImagePreviewStrip';
import SettingsPanel from './SettingsPanel';

export default function MusicControls({ vm, t, dictionaries }) {
  const hasImages = vm.musicImages.length > 0;
  const groups = [
    { title: t('videoGeneration.mv.generator.music.style'), items: dictionaries.options.style, value: vm.values.style, onChange: (v) => vm.updateValue('style', v) },
    { title: t('videoGeneration.mv.generator.music.mood'), items: dictionaries.options.mood, value: vm.values.musicMood, onChange: (v) => vm.updateValue('musicMood', v) },
    { title: t('videoGeneration.mv.generator.music.vocal'), items: dictionaries.options.vocal, value: vm.values.vocal, onChange: (v) => vm.updateValue('vocal', v) },
    { title: t('videoGeneration.mv.generator.music.language'), items: dictionaries.options.language, value: vm.values.language, onChange: (v) => vm.updateValue('language', v) },
    { title: t('videoGeneration.mv.generator.music.duration'), items: dictionaries.options.duration, value: vm.values.duration, onChange: (v) => vm.updateValue('duration', v) },
    ...(hasImages ? [{
      title: t('videoGeneration.mv.generator.music.mode'),
      items: dictionaries.options.imageMode || OPTIONS.imageMode,
      value: vm.values.musicMode,
      onChange: (v) => vm.updateValue('musicMode', v),
      isOptionDisabled: (item) => !hasImages && isSongwritingMode(item),
    }] : []),
  ];
  return (
    <>
      <MusicImageUpload vm={vm} t={t} />
      <div className="mv-field">
        <label>{t('videoGeneration.mv.generator.music.prompt')}</label>
        <textarea value={vm.values.musicPrompt} onChange={(e) => vm.updateValue('musicPrompt', e.target.value)} placeholder={t('videoGeneration.mv.generator.music.placeholder')} />
      </div>
      <SettingsPanel title={t('videoGeneration.mv.generator.music.settings')} groups={groups} t={t} />
    </>
  );
}

function MusicImageUpload({ vm, t }) {
  const onFiles = (event) => {
    const files = Array.from(event.target.files || []);
    if (files.length) vm.setMusicImages((prev) => [...prev, ...files].slice(0, 5));
    event.target.value = '';
  };
  const removeImage = (index) => {
    vm.setMusicImages((prev) => prev.filter((_, itemIndex) => itemIndex !== index));
  };
  return (
    <>
      <div className="mv-upload">
        <input type="file" accept="image/*" multiple onChange={onFiles} />
        <strong>{t('videoGeneration.mv.generator.music.upload')}</strong>
        <span>{vm.musicImages.length ? t('videoGeneration.mv.generator.music.selected', { count: vm.musicImages.length }) : t('videoGeneration.mv.generator.music.formats')}</span>
      </div>
      <ImagePreviewStrip images={vm.musicImages} onRemove={removeImage} />
    </>
  );
}

function isSongwritingMode(item) {
  const text = `${item.value || ''} ${item.label || ''}`.toLowerCase();
  return text.includes('songwriting') || text.includes('按图写歌') || text.includes('按圖寫歌');
}
